import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const YearNavWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${Spacing.lg}px;
`;

export const MonthList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
  align-items: center;
`;

export const MonthRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 20px;
  column-gap: 5vw;
  align-items: center;
  padding: ${Spacing.sm}px ${Spacing.md}px;
  background-color: ${ColorV2.White};
  border-radius: 12px;

  & > *:first-child {
    text-align: right;
  }
`;

export const Lables = styled.span`
  ${TypographyV2.h5};
  color: ${ColorV2.Blue1};
  line-height: 1;
`;

export const MonthTitle = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  line-height: 1;
`;
